import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import { MuiShadowIconButtonOverride, MuiSmallShadowIconButtonOverride } from 'theme/overrides';
var ShadowIconButton = withStyles(MuiShadowIconButtonOverride)(IconButton);
var SmallShadowIconButton = withStyles(MuiSmallShadowIconButtonOverride)(IconButton);
export { ShadowIconButton, SmallShadowIconButton };